import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import CardIcon from './CardIcon.js';

/** Adds padding to the card */ const CardContent = (_param)=> {
    var { children , variant ='normal' , center , className , childrenWrapperClassName  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "children",
        "variant",
        "center",
        "className",
        "childrenWrapperClassName"
    ]);
    return React.createElement("div", swcHelpers.extends({
        className: classnames('card-content', `card-content--${variant}`, className, {
            'card-content--center': center
        })
    }, rest), /*#__PURE__*/ React.createElement("div", {
        className: childrenWrapperClassName
    }, children), variant === 'link' ? /*#__PURE__*/ React.createElement(CardIcon, {
        name: "chevron-right",
        className: "card-content__link-icon"
    }) : null);
};
var CardContent$1 = CardContent;

export { CardContent$1 as default };
//# sourceMappingURL=CardContent.js.map
